import { formatDate } from './formatDate';

export function getDashedDate(date, pattern = 'dashed') {
  return formatDate(date, pattern);
}
